import { useParams, Link } from "react-router-dom";
import Stepper from "../../components/Stepper";

export default function EntreNos() {
  const { id } = useParams();

  return (
    <div
      className="page-bg"
      style={{ backgroundImage: 'url("/imagens/textura-hexagono-azul.png")' }}
    >
      <div className="evento-wrapper">
        <div className="evento-detalhe">
          <h1>Cadastro de visitante</h1>

          <div className="acoes">
            <Link
              to={`/evento/${id}/visitante`}
              className="acao-feinsul"
            >
              Continuar
            </Link>
          </div>
        </div>

        <Stepper etapaAtual={1} />
      </div>
    </div>
  );
}